module.exports = __webpack_public_path__ + "static/media/57f6daa3-a2b5-44e9-83cb-9cc2a49abc0d.6741b927.png";